import axios from 'axios';
import Cookies from 'universal-cookie';



const cookies = new Cookies();

export const getTypeApi = async (type: string,url:string):Promise<any> => {
    const token = cookies.get("authToken");
    try {
      const response = await axios.get(
        `${url}/taxonomy/get?type=${type}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data;
      } catch (error) {
        console.error("Error fetching taxonomy by type from:", `${url}/taxonomy/get?type=${type}`, error);
        throw error;
      }
    };

  
    export const getTaxonomyApi = async (type: string,url:string):Promise<any> => {
      const token = cookies.get('authToken');
      try {
        const response = await axios.get(
          `${url}/donation/gettaxonomy?type=${type}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data;
      } catch (error) {
        throw error;
      }
    };